import { render, staticRenderFns } from "./TractPayables.vue?vue&type=template&id=787e07c6&"
import script from "./TractPayables.vue?vue&type=script&lang=js&"
export * from "./TractPayables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports